import { defineMessages } from "react-intl";

export const messages = defineMessages({
  emptyText: {
    id: "RlfqSV",
    defaultMessage: "No orders found",
  },
  addOrder: {
    id: "uoKAmI",
    defaultMessage: "Add new order",
  },
  editOrder: {
    defaultMessage: "Edit order",
    id: "lwjzVj",
  },
  orders: {
    defaultMessage: "Order",
    id: "XPruqs",
  },
});

export const columnsMessages = defineMessages({
  number: {
    id: "kFkPWB",
    defaultMessage: "Number",
  },
  date: {
    id: "P7PLVj",
    defaultMessage: "Date",
  },
  customer: {
    id: "hkENym",
    defaultMessage: "Customer",
  },
  payment: {
    id: "NmK6zy",
    defaultMessage: "Payment",
  },
  status: {
    id: "NWxomz",
    defaultMessage: "Fulfillment status",
  },
  total: {
    id: "MJ2jZQ",
    defaultMessage: "Total",
  },
  channel: {
    defaultMessage: "Channel",
    id: "KeO51o",
  },
});
